<template>
  <div>
    <div class="container">
      <div class="card rounded shadow my-3">
        <div class="card-body text-center">
          <img src="/media/checked.svg" class="w-25 mx-auto" alt="checked">
          <h3 class="text-success my-3">
            <b>پرداخت موفق</b>
          </h3>
<!--          -->
          <div class="container">
            <div class="row dir-rtl">
              <div class="col-4 p-0">
                <label class="w-100 text-black-50 text-right">
                  مبلغ پرداختی :
                </label>
              </div>
              <div class="col-8 p-0 text-left dir-ltr">
                {{info.order.price | rial}}
<!--              -->
              </div>
              <div class="col-4 p-0">
                <label class="w-100 text-black-50 text-right">
                  رسید تراکنش :
                </label>
              </div>
              <div class="col-8 p-0 text-left">
                {{info.order.authority}}
<!--               -->
              </div>

<!--              <div class="col-4 p-0">-->
<!--                <label class="w-100 text-black-50 text-right">-->
<!--                  شماره کارت :-->
<!--                </label>-->
<!--              </div>-->
<!--              <div class="col-8 p-0 text-left">-->
<!--&lt;!&ndash;                                           &ndash;&gt;-->
<!--              </div>-->

              <div class="col-4 p-0">
                <label class="w-100 text-black-50 text-right">
                  تاریخ و ساعت :
                </label>
              </div>
              <div class="col-8 p-0 text-left dir-ltr">
                {{info.order.created_at | longDate}}
<!--                -->
              </div>
              <div class="col-12 p-0">
                <a class="btn btn-success w-100" href="" style="font-size: 16px">
                  <i class="fa fa-check"></i>
                  <b>بازگشت به سایت</b>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <label class="w-100 text-center text-black-50 dir-rtl" style="font-size: small">
        تمامی حقوق این نرم افزار برای کورلند محفوظ است .
      </label>
    </div>
  </div>
</template>
<script >
  export default {
    props : {
      info: {
        type: Object,
        required: true
      }
    }
  }
</script>